<template lang="pug">
  Picture(
    v-if="media.image"
    :show-spinner="false"
    :image="media.image"
    :lazy="true"
    :missing-icon="false"
    fit="fit"
    optimize="speed"
    :style="style"
  )
</template>

<script>
export default {
  name: 'Thumbnail',
  data: () => ({
    loaded: false
  }),
  props: {
    media: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 46
    },
    aspectRatio: {
      type: Number
    }
  },
  computed: {
    width() {
      let width;
      if (this.aspectRatio) width = this.hright * this.aspectRatio;
      else width = this.height * (this.media.image.width / this.media.image.height);
      return width;
    },
    style() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`
      };
    }
  }
};
</script>

<style lang="sass" scoped></style>
